import React from "react";
import { AdminManageContextProvider } from "./AdminListView";
import AdminList from "./views/AdminList";

const AdminManageListPage = () => {
  return (
    <div>
      <AdminManageContextProvider>
        <AdminList />
      </AdminManageContextProvider>
    </div>
  );
};

export default AdminManageListPage;
